import { TextField } from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoDetalle from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumentoDetalle';

interface ICampoCantidadEntregadaProps {
    deshabilitado: boolean;
    manejarCambioCampo: (
        nombreCampo: keyof IDocumentoDetalle,
        nuevoValor: IDocumentoDetalle[keyof IDocumentoDetalle]
    ) => any;
    valor: number | undefined;
}

const CampoCantidadEntregada: FunctionComponent<ICampoCantidadEntregadaProps> = ({
    deshabilitado,
    manejarCambioCampo,
    valor,
}) => (
    <TextField
        disabled={deshabilitado}
        fullWidth
        label={<Texto id="DetallesFormulario.CampoCantidadEntregada.Nombre" />}
        onChange={(event) => {
            if (/^\d*$/.test(event.target.value)) {
                manejarCambioCampo('CantidadEntregada', event.target.value);
            }
        }}
        value={valor}
        required
    />
);

export default CampoCantidadEntregada;
